<template>
  <div class="ty-mains">
    <div class="ty-contents whites">
      <div class="table">
        <div style="border: 1px solid hsl(223,21%,87%);margin-bottom: 20px;">
          <div style="display: flex;padding-left:0;">
            <div style="min-width: 140px;display: flex;justify-content: center;padding: 20px 0;border-right: 1px solid hsla(223, 22%, 87%, 1);">数据权限 ：</div>
            <div style="padding: 0 30px;">
              <el-radio-group v-model="radio" @change="sdauyg">
                <el-radio :label="1">查看所有人的数据</el-radio> <br />
                <el-radio :label="3">查看所属含子部门的部门数据</el-radio><br />
                <el-radio :label="2" :style="isShow === false ? 'margin-bottom: 20px;' : ''">查看指定含子部门的部门数据</el-radio>
              </el-radio-group>
              <div class="ty" v-show="isShow"><span @click="departmentShow">选择</span></div>
              <div v-if="this.radio === 2 && edit_department.length > 0">
                <div class="bi">
                  <el-tag
                    v-for="tag in edit_department"
                    :key="tag.value"
                    :type="tag.type">
                    <img src="../../assets/images/zuzhi.png" width="14px;" height="14px;">
                    {{ tag.label }}
                  </el-tag>
                </div>
                <div v-if="edit_department.length > 8" @click="open" class="ding">更多</div>
              </div>
            </div>
          </div>
        <!--  <el-select v-model="selectValue" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </div>
      </div>

      <div class="table01" v-loading="loading">
         <div class="tr" v-for="(auth, index) in authList" :key="auth.key">
          <template v-if="auth.children">
              <check-card
                :key="auth.key"
                :index="index"
                :all-options="authority[auth.id]"
                :check-options="auth.children"
                :checked="defaultAuth[index]"
                @get-checked="getChcked"
              ></check-card>
            </template>
        </div>
        <div style="border: 1px solid #d8dce6;"></div>
      </div>
      <p class="center">
        <el-button type="info" plain @click="$router.go(-1)">取消</el-button>
        <el-button style="width: 72px;" type="primary" @click="editPermission">保存</el-button>
      </p>
    </div>
    <Departmentatde
      :isShow="departmentShow2"
      @check-user="checkUser"
      v-if="departmentShow2"
      :checkeds="edit_department"
    ></Departmentatde>
  </div>
</template>
<script>
import _ from 'lodash'
import { authList, authArr } from './config/authList.js'
import checkCard from './components/checkCard'
import Departmentatde from '../../components/departmentat.vue'
import store from '@/store'
import { getCurrentAuth } from '@/utils/auth'
export default {
  components: {
    checkCard,
    Departmentatde
  },
  data() {
    return {
      authList,
      radio: 1,
      is_all: '',
      filterText: '',
      dialogVisible: false,
      departmentShow2: false,
      departmentData: [],
      loading: false,
      loading01: false,
      checkedDepartment: [],
      department_list: [],
      depapart_id: [],
      disabled: true,
      options: [
        {
          value: 1,
          label: '查看所有人的数据'
        },
        {
          value: 2,
          label: '查看所属部门（含子部门）的数据'
        }
      ],
      selectValue: 1,
      defaultAuth: [],
      checkedAuth: [...new Set(this.checked)],
      secondChecked: [],
      departid: [],
      checkAll: false,
      checkedOptions: [],
      checkedValue: [],
      sdsf2: [],
      authority: {},
      isShow: false,
      id: '',
      time: '',
      edit_department: [],
      checkedEmployees: []
    }
  },
  mounted() {
    this.getQuan()
    this.loading = true
    this.getAuthDetail()
  },
  watch: {
    checked(val) {
      this.checkedAuth = [...new Set(val)]
      this.checkAll = val.length > 0
    }
  },
  methods: {
    handleCheckAllChange(val) {
      // this.checkAll = this.checkedAuth.length > 0
      this.authority.forEach(k => {
        this.checkedAuth = val ? k.children : []
      })
      // this.isIndeterminate = false
      this.$emit('get-checked', val ? this.checkedOptions : [], this.index)

      // val && (this.checkedAuth = this.checkedOptions)
    },
    checkedChange(value) {
      const checkedCount = value.length
      this.checkAll = value.length > 0
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedOptions.length
      this.checkedValue = value
      this.$emit('get-checked', value, this.index)
    },
    getAuthDetail() {
      this.id = this.$route.query.code
      this.$api
        .get('api/system/role/index', {
          code: this.id
        })
        .then(res => {
          const defaultAuth = [[], [], [], [], [], [], [], []]
        //  this.department = res.department_data.split(',')
          if (res.item) {
            authArr.forEach(v => {
              res.item.forEach(item => {
                if (v.key === item) {
                  defaultAuth[v.parentId].push(item)
                }
              })
            })
          }
          this.aer = res.department_data
          this.defaultAuth = defaultAuth
          this.selectValue = res.role_look
          this.radio = res.role_look
          this.is_all = res.role_look
          // alert(res.role_look)
          if (this.radio === 2) {
            this.isShow = true
          }
          this.loading = false
          this.loading01 = false
          this.getDepartlist()
        })
    },
    getQuan() {
      this.$api.get('/api/v1/app/get/menu/label')
      .then(res => {
         const a = res
        for (let i = 0; i < authList.length; i++) {
          for (let j = 0; j < a.length; j++) {
            if (authList[i].id === a[j]) {
              this.sdsf2.push(authList[i])
              continue
            }
          }
        }
        const list = {}
        for (var key in this.sdsf2) {
          list[this.sdsf2[key].id] = this.sdsf2[key]
        }
        this.authority = list
      })
    },
    getChcked(value, index) {
      const authNode = [
        'mass',
        'warn',
        'audit',
        'wordSetting',
        'operationLog',
        'inherit',
        'sessionShare',
        'setting'
      ]
      for (let i = 0; i < this.defaultAuth.length; i++) {
        if (this.defaultAuth[i].length > 0) {
          if (index !== i) {
            this.checkedAuth.push(authNode[i])
            if (value.length <= 0) {
              this.defaultAuth[index] = []
            }
          } else {
            this.defaultAuth[index] = []
          }
        }
      }
      this.secondChecked[index] = value
      this.secondChecked.forEach((v, i) => {
        if (v.length > 0) {
          !this.checkedAuth.includes(authNode[i]) && this.checkedAuth.push(authNode[i])
        } else {
          this.delAuthItme(authNode[i])
        }
      })
    },
    delAuthItme(auth) {
      this.checkedAuth.forEach((v, index) => {
        if (v === auth) {
          this.checkedAuth.splice(index, 1)
        }
      })
    },
    sdauyg() {
      if (this.radio === 1) {
        this.is_all = 1
        this.isShow = false
      } else if (this.radio === 3) {
         this.is_all = 3
         this.isShow = false
      } else if (this.radio === 2) {
         this.is_all = this.radio
         this.isShow = true
         // this.getDepartment()
      }
    },
    checkUser(depaert_list) {
      console.log('aaaaaaaaaaaa', depaert_list)
      this.edit_department = depaert_list
      this.departmentShow2 = false
    },
    editPermission() {
      this.id = this.$route.query.code
      this.time = this.$route.query.time
      if (this.radio === 2) {
        this.is_all = 2
      }
      let item = [...this.checkedAuth, ...this.secondChecked.flat(), ...this.defaultAuth.flat()]
      this.edit_department.forEach(k => {
        this.departid.push(k.value)
      })
      if (this.radio === 1 || this.radio === 3) {
        this.departid = []
      }
      item = [...new Set(item)]
      this.$confirm('是否确认保存？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          this.$api
            .post('/api/system/bind/role', {
              code: this.id,
            //  role_look: this.selectValue,
              role_item: item,
              role_department: this.departid,
              is_all: this.is_all,
              lastUpdateTime: this.time
            })
            .then(async () => {
              const res = await getCurrentAuth()
              store.dispatch('addAuth', res)
              this.$router.push('/setting/role')
              // this.$router.go(0)
            })
        })
        .catch(() => {})
    },
    departmentShow() {
      this.departmentShow2 = true
    },
    getDepartlist() {
      this.$api
      .post('/api/system/manage/department/list', {
        department_id: this.aer
      }).then(res => {
        let arr = []
        arr = res.data
        arr.forEach(k => {
          this.edit_department.push({ label: k.name, value: k.department_id })
        })
      })
    },
    open() {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.table-z1{
  height: 1640px;width: 968px;
  border: 1px solid rgb(215, 219, 229);
  border-spacing: 0;
  border-collapse: collapse;
}
.table-z1 tr{
  //display: flex;
  //border: 1px solid #d8dce6;
  border-bottom: none;
}
.table-z1 td{
  //padding: 0;
  //display: flex;
  border: 1px solid #d8dce6;
  border-bottom: none;
}
.td01{
  display: flex;
}
.ty-mains{
   .ty-contents{
    overflow: auto;
    margin-top: 20px;
    padding: 20px;
    box-shadow: 0px 2px 10px 0px rgb(2 47 50 / 10%);
    border-radius: 10px;
    background: #fff;
   }
   .white{
      border-radius: 2px;
      padding: 20px 20px;
   }
}
.table {
  margin-top: 20px;
  overflow: auto;
  .tr {
    display: flex;
    border: 1px solid #d8dce6;
    border-bottom: none;
    padding-left: 20px;
    .td {
      display: flex;
      border: 1px solid #d8dce6;
      border-bottom: none;
    }
    &:last-child {
      border-bottom: 1px solid #d8dce6;
    }
  }
  .el-checkbox {
    // width: 140px;
    height: 40px;
    line-height: 40px;
  }
  .ty{
    width: 30px;
    position: relative;
    left: 214px;
    top: -16px;
    color:#204A9E;
    cursor:pointer;
  }
  .ty:hover{
    border-bottom: 1px solid #204A9E;
    cursor:pointer;
  }
}
.el-checkbox-group {
  display: flex;
  line-height: 40px;
  padding-left: 20px;
}
::v-deep .el-radio{
  margin-top: 24px;
}
::v-deep .el-radio__input.is-checked + .el-radio__label{
    color: #606266;
}
::v-deep .el-dialog .el-dialog__footer {
    text-align: right;
}
.bi{
  // width:90%;
  height:auto;
  max-height: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.el-tag{
  height: 26px;
  padding: 3px 5px;
  line-height: 16px;
  background: white;
  margin-bottom: 10px;
  margin-right: 10px;
  color:#606266;
  border: 1px solid #D8DCE6;
  opacity: 1;
  border-radius: 2px;
  img {
    position: relative;
    top: 2px;
  }
}
::v-deep .el-tag .el-tag__close{
  color: #606266;
}
.ding{
  position: relative;
  left:97%;
  top:-20px;
  width: 28px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #204A9E;
  z-index: 999;
  opacity: 1;
}
::v-deep .el-dialog__header{
  background: #FFFFFF;
  opacity: 1;
  border-radius: 2px;
}
::v-deep .el-card{
   box-shadow: none;
}
::v-deep .el-card__body{
  padding: 12px 24px;
  border-left: .0625rem solid rgb(2 47 50 / 10%);
}
::v-deep.el-tag .el-icon-close:hover{
    color: #204a9e;
}
::v-deep .el-tag .el-tag__close:hover{
    // position: relative;
    // top: 1px;
    color: #204a9e;
    font-weight: 600;
    background: #fff;
}
::v-deep .el-tag .el-icon-close::before {
    display: block;
    font-size: 14px;
}
::v-deep .home-main{
 // margin: ;
}
::v-deep .el-card__body .el-icon-close:before {
    font-size: 16px;
    right:10px;
}
::v-deep.el-checkbox__input:hover{
  color: #204A9E;
}
::v-deep .el-dialog__body{
  padding: 0;
}
::v-deep .el-button--primary.is-disabled{
  opacity: 0.7;
}
::v-deep .el-checkbox:last-of-type{
  margin-right: none;
}
</style>
